<template>
  <div class="diy-video" :style="'padding:'+itemStyle.paddingTop+'px 0'">
    <video
      :style="'height:'+itemStyle.height+'px'"
      :src="params.videoUrl"
      :poster="params.poster"
      :autoplay="params.autoplay == 1"
      controls
    ></video>
  </div>
</template>

<script>
// import { Swipe, SwipeItem } from 'vant';
// import Vue from "vue";
// Vue.use(Swipe).use(SwipeItem);
export default {
  props: ["itemIndex", "itemStyle", "params"],
  created() {},
  activated() {},
  methods: {}
};
</script>

<style lang="less" scoped>
@import url("../../style/skin.less");
.diy-video video {
  width: 100%;
  display: block;
}

</style>